export const forums = {
  forumsSearchInputPlaceholder: 'Sök',
  forumsFollowDiscussionButtonTitle: 'Följ',
  forumsFollowingDiscussButtonTitle: 'Följer',
  forumDiscussionInfoNoReplyText: 'Inga svar ännu',
  forumsDiscussionDetailsStartButtonTitle: 'Starta diskussion',
  forumDetailsCreatedByText: 'av',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Kopiera länk',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Rapportera innehåll',
  forumsReportedCurtainContent: 'Innehåll rapporterat',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Länk kopierad!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Nåla diskussion',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Avnåla diskussion',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Redigera diskussion',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Radera diskussion',
  forumsDiscussionDetailspPopupDeleteTitle: 'Radera',
  forumsDiscussionDetailspPopupDeleteText: 'Vill du radera denna diskussion?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Avbryt',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Bekräfta',
  forumsDiscussionDetailsDeleledAlertText: 'Diskussionen har raderats!',
  forumsNewDiscussionTitle: 'Ny diskussion',
  forumsNewDiscussionTitlePlaceholder: 'Rubrik...',
  forumsNewDiscussionBodyPlaceholderText: 'Skriv din text här...',
  forumsNewDiscussionPublishButtonTitle: 'Publicera',
  forumsNewDiscussionLocationCurtainTitle: 'Plats',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Platsnamn',
  forumsNewDiscussionEditLocationCurtainText: 'Redigera plats',
  forumsNewDiscussionDeleteLocationCurtainText: 'Radera plats',
  forumsNewDiscussionCreatePollTitle: 'Skapa omröstning',
  forumsNewDiscussionTitleInputPlaceholder: 'Rubrik',
  forumsNewDiscussionOptionInputPlaceholder: 'Alternativ',
  forumsNewDiscussionAddButtonTitle: 'Lägg till alternativ',
  forumsNewDiscussionCreateButtonTitle: 'Skapa',
  forumsNewDiscussionPollTitleBlankAlertText: 'Rubriken får inte vara tom!',
  forumsNewDiscussionPollOptionBlankAlertText: 'Alternativet får inte vara tomt!',
  forumsNewDiscussionPollLongTitleAlertText: 'Rubriken får vara högst 140 tecken',
  forumsNewDiscussionPollLongOptionAlertText: 'Alternativet får vara högst 25 tecken',
  forumsNewDiscussionEditPollIconText: 'Redigera omröstning',
  forumsNewDiscussionRemovePollIconText: 'Ta bort omröstning',
  forumsDiscardDraftPopupTitle: 'Utkast',
  forumsDiscardDraftPopupText: 'Vill du kasta detta utkast?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Avbryt',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Bekräfta',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Svara',
  forumsDiscussionDetailsNoCommentsText: 'Inga kommentarer ännu\nDu kan vara den första att kommentera',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Svara',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Kopiera länk',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Länk kopierad!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Rapportera innehåll',
  forumsDiscussionDetailsPostCurtainReportedText: 'Innehåll rapporterat',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Svara',
  forumsEditDiscussionTitle: 'Redigera diskussion',
  forumsEditDiscussionSaveButtonTitle: 'Spara',
  forumsEditedDiscussionSavedAlertText: 'Diskussionen har sparats!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Redigera svar',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Radera svar',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Kommentaren har sparats!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Kommentaren har raderats!',
  forumsAlertSomethinWrong: 'Något gick fel!',
  forumsMaxMbSize: 'Du kan bara ladda upp upp till {size} MB åt gången',
  forumsMaxAttachments: 'Du har överskridit antalet bilagor. Max antal bilagor är {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Radera',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Vill du radera denna kommentar?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Avbryt',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bekräfta',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Rapportera innehåll',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Innehåll rapporterat',
  forumDiscussionInfoLastReplyText: 'Senaste svar',
  forumsDiscussionAt: 'vid',
  forumsDiscussionDetailsFlagCurtainTitle: 'Rapportera innehåll',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Innehåll rapporterat',
  forumsPollInfoVotesText: 'röster',
  forumsPollInfoEditVoteText: 'Redigera röst',
  forumsPollFinishPollText: 'Avsluta omröstning',
  forumsPollFinishedPollText: 'Avslutad',
  forumsPollInProgresslText: 'Pågår',
  forumsPollCurtainTitle: 'Avsluta omröstning',
  forumsPollCurtainText: 'Användare kommer inte kunna rösta efter att omröstningen är avslutad.',
  forumsFinishPollCurtainCancelButtonTitle: 'Avbryt',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Bekräfta',
  forumsPollInfoPollVotesCurtainTitle: 'Omröstningsresultat'
}
